import { Number, Record, Static, String } from 'runtypes'

export const City = Record({
    id: Number,
    title: String,
    phone: String,
    coordinateX: Number,
    coordinateY: Number,
    mapZoom: Number
})

export type ICity = Static<typeof City>
